import React, { useCallback, useEffect, useState } from 'react';

import { ReactComponent as IconCheckWhite } from 'images/general/check-white.svg';
import { ReactComponent as IconFlagArIq } from 'images/flag/ar-IQ.svg';
import { ReactComponent as IconFlagHinava } from 'images/flag/hinava3.svg';
import { ReactComponent as IconFlagIr } from 'images/flag/ir.svg';
import { ReactComponent as IconFlagUnknown } from 'images/flag/unknown.svg';

import packageJson from '../../../../../package.json';

import './PhoneNumberInput.scss'
import { cleanPhoneNumber, markupPhoneNumber } from '../NumberInputHelper';


export default function PhoneNumberInput({ style, onPhoneNumberChange }) {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [countryCode, setCountryCode] = useState(packageJson.defaultCountryCode);
    const [drowDownOpen, setDrowDownOpen] = useState(false);

    const _onPhoneNumberInput = useCallback((e) => {
        let value = e.target.value;
        const codes = ["98", "964", "000"];
        for (let i = 0; i < codes.length; i++) {
            const _code = codes[i];
            if (value.startsWith("+" + _code)) {
                setCountryCode(_code)
                value = value.substring(1 + _code.length)
                break;
            }
        }
        setPhoneNumber(markupPhoneNumber(value))
    }, []);

    useEffect(() => {
        onPhoneNumberChange(countryCode, cleanPhoneNumber(phoneNumber));
    }, [onPhoneNumberChange, countryCode, phoneNumber])

    return (
        <div className="phone-number-input" dir="ltr" style={style}>
            <Country className={"country box"} code={countryCode}
                onClick={() => { setDrowDownOpen(!drowDownOpen) }} />

            <input className="input box" type="tel"
                placeholder={placeholder(countryCode)}
                value={phoneNumber} onChange={_onPhoneNumberInput}></input>

            {drowDownOpen ? <div className="country-dropdown box">
                <Country className={"country"}
                    code={"98"} check={"98" === countryCode}
                    onClick={() => { setCountryCode("98"); setDrowDownOpen(false); }} />
                <div className="line" />
                <Country className={"country"}
                    code={"964"} check={"964" === countryCode}
                    onClick={() => { setCountryCode("964"); setDrowDownOpen(false); }} />
            </div> : null}
        </div>
    )
}


function Country({ className, code, check, onClick }) {
    return <div className={className} onClick={onClick}>
        {React.createElement(flagIcon(code), { className: "icon" })}
        <div>{countryName(code)}</div>
        <div>+{code}</div>
        {check ? <IconCheckWhite className="check-icon" /> : null}
    </div>
}

function flagIcon(countryCode) {
    switch (countryCode) {
        case "98":
            return IconFlagIr
        case "964":
            return IconFlagArIq
        case "000":
            return IconFlagHinava
        default:
            return IconFlagUnknown
    }
}

function placeholder(countryCode) {
    switch (countryCode) {
        case "98":
            return "912 345 6789"
        case "964":
            return "700 123 4567"
        case "000":
            return "12 345 6789"
        default:
            return ""
    }
}

function countryName(countryCode) {
    switch (countryCode) {
        case "98":
            return "Iran"
        case "964":
            return "Iraq"
        case "000":
            return "Hinava"
        default:
            return ""
    }
}